import { PencilIcon, TrashIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function CertificationsTableRow({ certification, onDelete }) {
	const { t } = useTranslation()

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-3 px-4 border-b border-gray-200">
				<span className="font-medium text-gray-900">{certification?.name || '—'}</span>
			</td>
			<td className="py-3 px-4 border-b border-gray-200">
				<span className="text-gray-700">{certification?.description || '—'}</span>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 text-right">
				<div className="inline-flex items-center gap-2">
					<Link
						to={`/centrumSzkolen/certyfikaty/edit/${certification?._id}`}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100"
					>
						<PencilIcon className="h-4 w-4" />
						{t('trainingCertifications.list.table.edit')}
					</Link>
					<button
						type="button"
						onClick={() => onDelete(certification)}
						className="inline-flex items-center gap-1 rounded-md border border-red-100 bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100"
					>
						<TrashIcon className="h-4 w-4" />
						<span>{t('trainingCertifications.list.table.delete')}</span>
					</button>
				</div>
			</td>
		</tr>
	)
}
